import React from "react";

import { Translate } from "@/app/application/Translate";
import { Typography } from "@mui/material";

export const FallBackErrorMessage = () => {
	return (
		<Typography>
			<Translate String={"Training.SomethingWentWrong"}>
				Something went wrong
			</Translate>
		</Typography>
	);
};
